import React from 'react';

export enum YesNoFlag {
  Y = 'Y',
  N = 'N'
}

export type SelectOption = {
  value: string|number,
  label: string,
}

export type ConfirmModalData = {
  show?: boolean,
  data: {
    onConfirm: () => void,
    ssoToBeSelected?: string,
  },
}

export type ShowAlertFunction = (content: string, type: string) => void;

export type AlertType = {
  show: boolean,
  content: React.ReactNode | string,
  alertType: string,
};

export type Period = {
  name: string, taxYear: string,
}

export type Connection = {
  connName: string, connErpName: string,
}

export type CalculationId = {
  label: string, value: number,
}

export type FieldError = {type: string, message: string}

export type ValidationData<T> = Partial<Record<keyof T, FieldError[]>>;

export type WithValidationData<T> = T & {
  validationData?: ValidationData<T>
}

export type ValidationResult<T extends Record<string, unknown>> = Record<number, ValidationData<T>>
